import axios from '@/utils/request'

const ApiUrl = '/admin_api/v1/service/invoice'

/**
 * @description: 结算记录列表
 * @param {*} params
 * @return {*}
 */
export function getList(params) {
  return axios.get(`${ApiUrl}/list/`, {
    params
  })
}

/**
 * @description: 确认结算
 * @param {*} data
 * @return {*}
 */
export function accountConfirm(data) {
  return axios.post(`${ApiUrl}/confirm/`, data)
}

/**
 * @description: 补偿费用
 * @param {*} data
 * @return {*}
 */
export function setCompensationFee(data) {
  return axios.post(`${ApiUrl}/set_compensation_fee/`, data)
}

export function exportAccounting(params) {
  return axios.get(`${ApiUrl}/export/`, { params })
}

/**
 * @description: 批量确认结算
 * @return {*}
 */

export function allBatchConfirm(data) {
  return axios.post(`${ApiUrl}/batch_confirm/`, data)
}

export function cancelBatch(data) {
  return axios.post(`${ApiUrl}/cancel/`, data)
}
